import { render, staticRenderFns } from "./set-stage.vue?vue&type=template&id=1ee65149&scoped=true&"
import script from "./set-stage.vue?vue&type=script&lang=js&"
export * from "./set-stage.vue?vue&type=script&lang=js&"
import style0 from "./set-stage.vue?vue&type=style&index=0&id=1ee65149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee65149",
  null
  
)

export default component.exports